// extracted by mini-css-extract-plugin
export var allRightsReserved = "Footer-module--all-rights-reserved--621f6";
export var footerBaseLinkSection = "Footer-module--footer-base-link-section--90257";
export var footerBaseSection = "Footer-module--footer-base-section--b2b3e";
export var footerBaseUl = "Footer-module--footer-base-ul--b7f67";
export var footerColumnSection = "Footer-module--footer-column-section--f14a5";
export var footerCopyright = "Footer-module--footer-copyright--f55cb";
export var footerHeading = "Footer-module--footer-heading--196a1";
export var footerInnerContainer = "Footer-module--footer-inner-container--0f946";
export var footerLi = "Footer-module--footer-li--a9956";
export var footerLinks = "Footer-module--footer-links--32fef";
export var footerSectionBorder = "Footer-module--footer-section-border--4aa6a";
export var globalFooter = "Footer-module--global-footer--28e69";
export var localeSelector = "Footer-module--locale-selector--8bb8f";